const registerUserDictPT = {
  referralUsername: "Nome de usuário do referidor",
  nameOfUserRefferalCodeInvalid: "Nome de usuário do referidor inválido.",
  doYouHave: "Você tem um referidor?",
  iHaveReferral: "Eu tenho um referidor",
  yes: "Sim",
  no: "Não",
  voucher: "Código do voucher",
  doYouHaveVoucher: "Você tem um voucher?",
  username: "Nome de usuário",
  password: "Senha",
  confirmPassword: "Confirme a senha",
  fullName: "Nome completo",
  firstName: "Nome",
  surname: "Sobrenome",
  documentNumber: "CPF",
  documentNumberPJ: "CNPJ",
  selectCurrency: "Selecione uma moeda",
  terms: "Eu aceito os termos e condições.",
  marketingEmail: "Receber emails sobre atualizações e promoções?",
  recaptcha: "Reverificar ReCaptcha",
  signUp: "Registrar",
  proceedToPayment: "Ir para pagamento",
  payWithExtracoin: "Pagar com extracoin",
  coupon: "Cupom de registro",
  iHaveInviteCoupon: "Tenho um cupom de convite",
  enterInviteCoupon: "Informe o código do cupom de convite",
  inviteCouponRequired: "Informe o código do cupom de convite.",
  uploadDocPic: "Carregar foto do documento",
  on: "em",
  salePromoterRefExplanation:
    "Só se pode registrar como Promoter através de um link de referimento de um Manager.",
  // toast
  referralUserNotFound: "Usuário referidor não encontrado.",
  invalidCoupon: "Cupom de crédito inválido.",
  couponDoesNotBelong: "O cupom não pertence a esse usuário referidor.",
  genericError: "Ocorreu um erro. Por favor, tente novamente.",
  passwordMin8: "A senha deve ter pelo menos 8 caracteres.",
  pleaseReverify: "Por favor, complete a verificação ReCAPTCHA.",
  paymentCheckout: "Pagamento",
  phoneConfirmation: "Confirmação por telefone",
  phoneConfirmCodeExplanationPt1: "Enviamos uma mensagem via SMS para",
  phoneConfirmCodeExplanationPt2:
    "com seu código de confirmação, por favor insira o código abaixo para finalizar seu cadastro.",
  phoneConfirmCode: "Código de confirmação",
  pleaseUploadDocPic: "Carregue uma foto do seu documento de identidade",
  shippingRules: "Atenção: Não é possível utilizar a cotação de frete!",
  shippingRulesExplanation:
    "Nosso serviço de envios está disponível apenas usuários que remetem de endereços da Itália!",
  iKnow: "Estou ciente",
  alreadyHaveAccount: "Já tem uma conta?",
  emailCanBeSpam: "Verifique sua caixa de spam, o email pode estar lá.",
  doubts: "Dúvidas?",
  payNow: "Pagar agora",
  doLogin: "Fazer login",
  termsAndConditions: "Termos e condições",
  createFreeAccount: "Criar conta gratuita",
  youAreRegistering: "Você está se registrando como",
  createAccount: "Criar conta",
  registrationSuccessActivateYourAccount:
    "Cadastro realizado com sucesso! Por favor, verifique seu e-mail para ativar sua conta.",
  loginAndContinuePurchase: "Entre e continue a sua compra",
  customerRegisterTitle: "Comece a ganhar mais com o que você já compra.",
  customerRegisterDescription:
    "Como Customer Extraconomy, cada compra pode voltar para você em forma de Extracréditos, um crédito complementar que você usa como parte do pagamento dentro da plataforma.",
  customerRegisterSubtitle: "Receba Extracréditos sempre que comprar em parceiros da Extraconomy.",
  registerRoleCustomer: "CUSTOMER",
  registerRoleStore: "STORE",
  registerRoleManager: "MANAGER",
  registerRoleManagerAssociation: "MANAGER ASSOCIATION",
  registerRolePartner: "PARTNER",
  registerRoleSeller: "SELLER",
  registerRolePromoter: "PROMOTER",
  managerRegisterTitle: "Expanda sua influência como Manager.",
  managerRegisterDescription:
    "Como Manager, você constrói e lidera uma rede de negócios, conectando pessoas e empresas em uma economia colaborativa.",
  managerRegisterSubtitle: "Lidere. Conecte. Transforme sua região.",
  managerRegisterSubtitleAssociation:
    "Você está se registrando como Manager Association. Envie o documento da associação para concluir o cadastro.",
  associationPdfLabel: "Documento da associação (PDF)",
  associationPdfRequired: "Envie o documento PDF da associação para continuar.",
  associationPdfInvalidType: "O arquivo deve ser um PDF.",
  associationPdfTooLarge: "O arquivo PDF deve ter no máximo 10 MB.",
  removeFile: "Remover",
  storeRegisterTitle: "Leve sua loja física para o digital com a Extraconomy.",
  storeRegisterDescription:
    "O cadastro Store é gratuito e cria sua base para ativar vendas on-line com o plano Start Seller quando quiser.",
  storeRegisterSubtitle: "Crie sua conta Store e evolua para vender no marketplace no seu ritmo.",
  promoterRegisterTitle1: "Seja um Promoter.",
  promoterRegisterTitle2: "Conecte, Cresça, Transforme.",
  promoterRegisterDescription:
    "Na Extraconomy, cada conexão conta. Ofereça consultoria, conecte empresas, gere oportunidades e construa uma economia colaborativa que valoriza pessoas e resultados sustentáveis.",
  promoterRegisterSubtitle: "Construa impacto. Gere valor. Seja parte da mudança.",
  partnerRegisterTitle: "Seja um Partner. Compartilhe, Cresça, Valorize.",
  partnerRegisterDescription:
    "Entre na rede da Extraconomy dedicada aos profissionais. Crie sua vitrine digital, promova seus serviços comerciais e construa conexões de valor que transformam o networking em oportunidades concretas e receitas compartilhadas.",
  partnerRegisterSubtitle: "Crie rede. Desenvolva seu negócio. Seja parte da mudança.",
  sellerRegisterTitle: "Lance seu e-commerce na Extraconomy. Vender, Escalar, Digitalizar.",
  sellerRegisterDescription:
    "Entre na rede digital projetada para quem vende online. Ative sua plataforma de e-commerce, gerencie seus produtos com total autonomia e aumente suas vendas rumo a novos mercados com comissões justas e competitivas.",
  sellerRegisterSubtitle: "Venda para qualquer lugar. Maximize seus lucros. Seja parte da mudança.",
  registerSEODescription:
    "Registre-se na Extraconomy para acessar sua conta, expandir sua rede e aproveitar oportunidades exclusivas de negócios.",
  createYourAccount: "Crie sua conta",
};

export default registerUserDictPT;
